export default {
  globalNavigation: 'Global.Navigation',
  platformAdminVoiceActions: 'PlatformAdmin.VoiceActions',
  userSettingsDisplayNewSPA: 'UserSettings.displayNewSPA',
  launchpadConnect: 'Launchpad.Connect',
  moonshotOutage: 'Moonshot.Outage',
  globalNavigationPresenceCheck: 'Global.Navigation.presenceCheck',
  crmCalendar: 'CRM.Calendar',
  connectPresenceCheck: 'Connect.presenceCheck',
  dndStatus: 'Global.DNDStatus',
  purchaseLicenseFlow: 'PlatformAdmin.PurchaseLicenseFlow',
};
